// extracted by mini-css-extract-plugin
module.exports = {"mobilePlayer":"_normal--mobilePlayer--2QdpF","active":"_normal--active--3_upJ"};